import SalaryReport from '../../../views/Personnel/Report/SalaryReport.report.view';

export default SalaryReport;
